module.exports = __webpack_public_path__ + "img/greytomoyukism.0005ceee.webp";